import AboutUsPage from './about-us-page';

export default AboutUsPage;
